import { useEffect, useState } from "react";

// A tab left open keeps running the version it loaded. When the person comes back to it (and every 15 minutes), check
// whether a newer Books has been published; if so, offer a reload rather than letting them carry on with the old one.
const mine = () => [...document.scripts].map((s) => s.src).find((s) => /\/assets\/index-[^/]+\.js$/.test(s)) ?? null;
export function UpdateNotice() {
  const [fresh, setFresh] = useState(false);
  useEffect(() => {
    const current = mine();
    if (!current) return;                         // development: nothing to compare
    let last = 0;
    const check = async () => {
      if (Date.now() - last < 60_000) return;
      last = Date.now();
      try {
        const html = await (await fetch("/", { cache: "no-store" })).text();
        const m = html.match(/\/assets\/index-[^"']+\.js/);
        if (m && !current.endsWith(m[0])) setFresh(true);
      } catch { /* offline: try later */ }
    };
    const onVisible = () => { if (document.visibilityState === "visible") void check(); };
    document.addEventListener("visibilitychange", onVisible);
    const t = setInterval(() => void check(), 15 * 60_000);
    return () => { document.removeEventListener("visibilitychange", onVisible); clearInterval(t); };
  }, []);
  if (!fresh) return null;
  return (
    <div className="update-notice" role="status">
      <span>A newer version of Books is ready.</span>
      <button className="primary" onClick={() => location.reload()}>Reload</button>
    </div>
  );
}
